const styles = (theme) => ({
    wrap: {
        display: 'flex',
        overflow: 'hidden',
        fontSize: '0.7rem',
        justifyContent: 'space-between'
      },
      section1: {
        marginBottom: theme.spacing(2),
      }
});

export default styles;
